@if (!loading) {
<div class="modal-wrapper">
  <div class="modal-header modal-header--custom">
    <div class="modal-header__title">
      <div class="modal-icon"><mat-icon>person</mat-icon></div>
      <h4>{{ editUser ? 'Edit' : 'Add' }} User</h4>
    </div>
    <button mat-icon-button class="modal-close-btn" (click)="activeModal.close('close')" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body modal-form-body">
    <form [formGroup]="entryForm" novalidate>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>User Email</mat-label>
        <input matInput formControlName="email"
               placeholder="email@draexlmaier.com"
               list="UserL" (change)="changeUser($event)" />
        <datalist id="UserL">
          @for (user of userList; track user.Email) {
            <option [value]="user.Email">{{ user.Email }}</option>
          }
        </datalist>
        @if (entryForm.controls['email'].hasError('required')) {
          <mat-error>Email is required</mat-error>
        }
        @if (entryForm.controls['email'].hasError('invalidDomain')) {
          <mat-error>Must end with draexlmaier.com</mat-error>
        }
        @if (!editUser) {
          <mat-hint>You can add multiple emails separated by commas.</mat-hint>
        }
      </mat-form-field>
    </form>
  </div>

  <div class="modal-footer modal-footer--custom">
    @if (!editUser) {
      <button mat-flat-button color="primary" class="modal-action-btn"
              [disabled]="entryForm.invalid"
              (click)="onCreate_Update()">
        <mat-icon>add</mat-icon> Add
      </button>
    }
    @if (editUser) {
      <button mat-stroked-button color="warn" class="modal-action-btn"
              [disabled]="entryForm.invalid"
              (click)="openConfirmModal('Are you sure you want to Delete?')">
        <mat-icon>delete</mat-icon> Delete
      </button>
    }
  </div>
</div>
}

@if (loading) {
  <app-loading-spinner></app-loading-spinner>
}
